const React = require('react');
const {displayAmountAdmin, displayAmountMerchant} = require('../../utils/displayAmountData');

const displayAmountFCCtor = (C) => ({fiat = {}, crypto = {}}) => {
  return (
    <>
      <div className="lh16 fw7">
        <C {...fiat} type="fiat" />
      </div>
      <div className="c717275 lh16 fw4">
        <C {...crypto} type="coin" />
      </div>
    </>
  )
};

module.exports = {
  DisplayAmountFCAdmin: displayAmountFCCtor(displayAmountAdmin),
  DisplayAmountFCMerchant: displayAmountFCCtor(displayAmountMerchant)
};
